import { render, staticRenderFns } from "./MegaApp.vue?vue&type=template&id=70e42711&"
import script from "./MegaApp.vue?vue&type=script&lang=js&"
export * from "./MegaApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MegaApp.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib'
installComponents(component, {
  VContent,
})
